import {useMutation} from "@tanstack/react-query";

import {addServiceFunctionMutationOptions} from "./add-service-function.mutation-options";

export function useAddServiceFunction(id: string) {
  return useMutation(addServiceFunctionMutationOptions(id));
}
